import { Launch } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { Member } from '../models/member';

type MemberDetailExternalLinksProps = {
  member: Member;
};

export const MemberDetailExternalLinks = (props: MemberDetailExternalLinksProps) => {
  const { member } = props;

  const ExternalLink = ({ text, link }) => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, ml: 1 }}>
        <Launch fontSize='small' sx={{ mr: 1 }} />
        <Link to={link} target='_blank'>
          {text}
        </Link>
      </Box>
    );
  };

  if (!(member.memberOffers?.links?.length > 0)) return null;

  return (
    <Grid item xs={12}>
      <ContentSection header={member.memberOffers.heading}>
        {member.memberOffers.links.map((item) => (
          <ExternalLink link={item.offerLink} text={item.offerName} key={item.offerLink} />
        ))}
      </ContentSection>
    </Grid>
  );
};
